import { render, staticRenderFns } from "./DaftarPeriksa.vue?vue&type=template&id=40c64110&"
import script from "./DaftarPeriksa.vue?vue&type=script&lang=js&"
export * from "./DaftarPeriksa.vue?vue&type=script&lang=js&"
import style0 from "./DaftarPeriksa.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports